// Types
import { FlairType } from '@breakroom-nx/helpers';

// Assets
import { theme } from '@breakroom-nx/assets';

// Icons
import {
  LightningBoltIcon as LeaderIcon,
  StarIcon as SaverIcon,
} from 'react-native-heroicons/solid';

export class Flair {
  type?: FlairType;

  constructor(type?: FlairType) {
    this.type = type;
  }

  getColor() {
    switch (this.type) {
      case FlairType.Leader:
        return theme.colors.yellow[200];

      case FlairType.Saver:
        return theme.colors.blue[200];
    }
  }

  getIcon(
    size: number,
    borderColor: string = theme.colors.surface[100]
  ): JSX.Element | undefined {
    switch (this.type) {
      case FlairType.Leader:
        return (
          // <LeaderIcon
          //   size={size}
          //   color={this.getColor()}
          //   stroke={
          //     borderColor === 'white' ? theme.colors.surface[200] : borderColor
          //   }
          //   strokeWidth={size < 90 ? 1.3 : 1.7}
          // />
          undefined
        );
      case FlairType.Saver:
        return (
          // <SaverIcon
          //   size={size + 2}
          //   color={this.getColor()}
          //   stroke={
          //     borderColor === 'white' ? theme.colors.surface[200] : borderColor
          //   }
          //   strokeWidth={size < 90 ? 1.3 : 1.7}
          // />
          undefined
        );
    }
  }
}
